import PASelectChanges from './directives/PASelectChanges';
import PAFlow from './directives/PAFlow';
import PAAddressChange from './directives/PAAddressChange';
import PAAddressChangeEdit from './directives/PAAddressChangeEdit';
import PADrivers from './directives/PADrivers';
import PADriversEdit from './directives/PADriversEdit';
import PAVehicles from './directives/PAVehicles';
import PAVehiclesEdit from './directives/PAVehiclesEdit';
import PACoverages from './directives/PACoverages';
import PACoveragesEdit from './directives/PACoveragesEdit';
import PAPolicyChanges from './directives/PAPolicyChanges.js';
import EditDriver from 'edge/endorsement/pa/directives/PAPolicyChangeEditDriver';
import EditVehicle from 'edge/endorsement/pa/directives/PAPolicyChangeEditVehicle';

import 'edge/platform/widgets/modal/module';
import 'edge/platform/widgets/inputs/module';
import 'edge/platform/widgets/loading/module';
import 'gw-portals-viewmodel-angular/aspects/module';
import 'edge/platform/widgets/basicinputs/module';
import 'edge/platform/flow/module';
import 'edge/platform/widgets/wizard/module';
import 'portalConfig';

export default angular.module('edge.endorsement.pa.app', ['portal.config', 'edge.platform.base', 'edge.platform.widgets.inputs', 'edge.platform.widgets.loadingMsg', 'edge.platform.widgets.modal', 'gw-portals-viewmodel-angular.aspects', 'edge.platform.widgets.basicinputs', 'edge.platform.flow', 'edge.platform.widgets.wizard']).directive('gwEndorsementPaSelectChanges', PASelectChanges).directive('gwEndorsementPaFlow', PAFlow).directive('gwEndorsementPaAddressChange', PAAddressChange).directive('gwEndorsementPaAddressChangeEdit', PAAddressChangeEdit).directive('gwEndorsementPaDrivers', PADrivers).directive('gwEndorsementPaDriversEdit', PADriversEdit).directive('gwEndorsementPaVehicles', PAVehicles).directive('gwEndorsementPaVehiclesEdit', PAVehiclesEdit).directive('gwEndorsementPaCoverages', PACoverages).directive('gwEndorsementPaCoveragesEdit', PACoveragesEdit).directive('gwEndorsementPaPolicyChanges', PAPolicyChanges).directive('gwAmpPaPolicyChangeEditDriver', EditDriver).directive('gwEndorsementPaEditVehicle', EditVehicle).constant('VinLookupEnabled', true);


//////////////////
// WEBPACK FOOTER
// ./common/grunt/webpack/loaders/conditional?if=endorsement-products&equals=PersonalAuto!./common/js/src/edge/endorsement/pa/app.js
// module id = 445
// module chunks = 0